export const apiUrls = {
  login: "onboarding/login",
  forgotPassword: "onboarding/forgotPassword",
  verifyOtp: "onboarding/verifyOtp",
  reset: "onboarding/reset",
  resetPassword: "onboarding/resetPassword",
  changePassword: "onboarding/changePassword",
  profile: "onboarding/getProfile",
  updateProfile: "onboarding",
  uploadFile: "files",
  uploadManyFiles: "files/bulk-upload/",
  logout: "onboarding/logout",
  cms: "cms",
  subAdmin: "subadmin",
  accessRole: "subadminaccess",
  addLandLord: "users",
  getLandLord: "users/list",
  getProperties: "property/list",
  getPropertyById: "property",
  getTenants: "property/lease/list",
  getTenantsById: "property/lease",
  addProperty: "property",
  getSupport: "support/list",
  getSupportById: "support",
  deleteSupport: "support",
  supportReply: "support/reply",
  maintenanceTicketsList: "maintenance/list",
  getSettings: "settings",
  getSubscriptionType: "settings/list-subscription",
  updateSettings: "settings/update",
  addSubscriptionType: "settings/add-subscription-type",
  updateSubscriptionType: "settings/update-subscription",
  usersList: "master/masterData",
  addNotification: "notification",
  notificationList: "notification",
  ticket:'maintenance',
  getDashboard: 'master/dashboard',
  getUserGraph: 'master/userGraph',
  getSubscriptionListing: "subscription/list",
  subscription: "subscription",
  masterListing: "master/masterData",
  notificationPreferences: "auth/setings/"
};
